// eslint-disable-next-line no-unused-vars
const exampleEvent = {
    type: 'game-over',
    time: 3454353,
    distance: 4325345,
    velocity: 43543
};

export default class GameLoggerModel {
    #log = [];

    get log() {
        return this.#log;
    }

    clearLog() {
        this.#log = [];
    }

    addEvent(type, params = {}) {
        const {
            time, distance, velocity, ...other
        } = params;

        this.#log.push({
            type,
            time,
            distance,
            velocity,
            ...other
        });
    }
}
